import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import SMETechFocusMain from './components/SMETechFocusMain'
import GeoCartographyMainPage from './components/GeoCartographyMainPage'
import NSWTransitPage from './components/NSWTransitPage'
import DashboardLogin from './components/dashboard_login'
import TailwindSamplePage from './components/TailwindSamplePage'
import DashboardLayout from './components/dashboard/DashboardLayout'
import OverviewPage from './components/dashboard/pages/OverviewPage'
import ImagesPage from './components/dashboard/pages/ImagesPage'
import AudioPage from './components/dashboard/pages/AudioPage'
import AdminUsersPage from './components/dashboard/pages/AdminUsersPage'
import MarketsPage from './components/dashboard/pages/MarketsPage'
import StockQuotePage from './components/dashboard/pages/StockQuotePage'
import MoversPage from './components/dashboard/pages/MoversPage'
import OptionsCalculatorPage from './components/dashboard/pages/OptionsCalculatorPage'
import InvoicesPage from './components/dashboard/pages/InvoicesPage'
import InvoiceDetailPage from './components/dashboard/pages/InvoiceDetailPage'
import ClientsPage from './components/dashboard/pages/ClientsPage'
import InvoiceSettingsPage from './components/dashboard/pages/InvoiceSettingsPage'
import { RequireDashboardAuth } from './hooks/useDashboardSession'
import './App.css'

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          {/* ── Public routes (transit, home, etc.) — unchanged ── */}
          <Route path="/" element={<SMETechFocusMain />} />
          <Route path="/geocartography" element={<GeoCartographyMainPage />} />
          <Route path="/nsw-transit" element={<NSWTransitPage />} />
          <Route path="/tailwind-demo" element={<TailwindSamplePage />} />
          <Route path="/dashboard/login" element={<DashboardLogin />} />

          {/* ── Dashboard — auth-gated, config-driven navigation ────────────
              HOW TO ADD A NEW SECTION (e.g. "Markets"):
                1. Add an entry to src/components/dashboard/navConfig.ts
                   (a leaf NavItem, or a NavGroup if it has sub-pages).
                2. Create the page(s) in src/components/dashboard/pages/
                3. Add one <Route> child below per leaf path — that's it.
          ── */}
          <Route
            path="/dashboard"
            element={
              <RequireDashboardAuth>
                <DashboardLayout />
              </RequireDashboardAuth>
            }
          >
            <Route index element={<OverviewPage />} />
            <Route path="images" element={<ImagesPage />} />
            <Route path="audio" element={<AudioPage />} />
            <Route path="admin/users" element={<AdminUsersPage />} />
            <Route path="markets" element={<MarketsPage />} />
            <Route path="markets/stock-quote" element={<StockQuotePage />} />
            <Route path="markets/movers" element={<MoversPage />} />
            <Route path="options-calculator" element={<OptionsCalculatorPage />} />
            <Route path="invoicing" element={<InvoicesPage />} />
            <Route path="invoicing/clients" element={<ClientsPage />} />
            <Route path="invoicing/settings" element={<InvoiceSettingsPage />} />
            {/* Detail route — not in navConfig.ts; navigated to from InvoicesPage. */}
            <Route path="invoicing/invoice/:invoiceId" element={<InvoiceDetailPage />} />
          </Route>
        </Routes>
      </div>
    </Router>
  )
}

export default App
